import React from 'react';
import { styled } from '@teko/ui';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? "#f5f5f5" : "#fff"};
    padding: 0.6rem;
    cursor: ${props.onClick ? "pointer" : ""};
    &:hover {
      background-color: ${props.type !== "search-suggestion" && "#f5f5f5"};
    }
  `);
const Title = styled.div`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = React.forwardRef((_a, ref) => {
  var _b = _a, {
    leading,
    title,
    trailing,
    numberOfLine = 1,
    onClick,
    onMouseEnter,
    type,
    selected = false
  } = _b, props = __objRest(_b, [
    "leading",
    "title",
    "trailing",
    "numberOfLine",
    "onClick",
    "onMouseEnter",
    "type",
    "selected"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({
    ref,
    selected,
    onMouseEnter
  }, props), {
    onClick,
    type
  }), leading, /* @__PURE__ */ React.createElement(Title, {
    numberOfLine
  }, title), trailing);
});
ListTile.displayName = "ListTile";

export { ListTile };
